<template>
  <div class="information">
    <div class="left">
      <div :class="'top-img' + (imageUrl ? '' : ' show-bg')">
        <a target="_blank" :href="productUrl"><a-image :src="selectImageUrl || imageUrl" v-if="imageUrl"
            :preview="false" /></a>
      </div>
      <div class="bottomUrlContainer" v-if="imageUrls?.length">
        <div class="bottomUrl">
          <div v-for="(item, index) in imageUrls" @click="changeImageUrl(item, index)" :style="{
            border:
              selectImageIndex === index
                ? '1px solid var(--Brand-Primary, #6C3DF2)'
                : '',
          }" :key="index" class="bottomUrlItem">
            <a-image :src="item" :preview="false" />
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="info">
        <div class="info-head">
          <h1>{{ title }}</h1>
          <a target="_blank" :href="productUrl">Amazon Detail Page<svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-tiaozhuan"></use>
            </svg></a>
        </div>
        <div class="info-body">
          <p>
            <span>ASIN:</span>
            <span>{{ asin }}</span>
          </p>
          <p>
            <span>Brand:</span>
            <span><a target="_blank" :href="'/publisher/brands/' + brandId">{{
              brandName
            }}</a></span>
          </p>
          <p>
            <span>Marketplace:</span>
            <span>
              <span class="marketplace">
                <svg class="icon" aria-hidden="true" style="font-size: 20px">
                  <use :xlink:href="MARKET_PLACE_MAP[countryCode]?.icon"></use>
                </svg>
                <span>{{ MARKET_PLACE_MAP[countryCode]?.label }}</span>
              </span>
            </span>
          </p>
          <p>
            <span>Category:</span>
            <span><a @click="onGoToProductList" href="/publisher/products">{{
              category
            }}</a></span>
          </p>
          <p>
            <span>Price:</span>
            <price-deal-layout v-if="combineDeal" :record="combineDeal" />
            <span v-else>{{ currencySymbol }}{{ Number(price).toFixed(2) }}</span>
          </p>
          <p>
            <span>Availiability:</span>
            <span>{{ availiabilityText }}</span>
          </p>
          <!-- <p>
            <span>Commission:</span>
            <span class="commission">
              <span>{{ commission }}%</span>
              <a-button class="history" @click="open = true">
                <i class="iconfont icon-lishijilu" />
              </a-button>
            </span>
          </p> -->
          <p>
            <span>Best Seller Rank:</span>
            <span>{{ bestSellerRank }}</span>
          </p>
          <p>
            <span>Est. Payout:</span>
            <span>{{ currencySymbol }}{{ Number(estPayout).toFixed(2) }}</span>
          </p>
          <p>
            <span>Rating:</span>
            <span>{{ productStarRating }}</span>
          </p>
          <p v-if="otherCountryCodes?.length" style="align-items: center">
            <span>Other Marketplace:</span>
            <span class="other-countries">
              <a target="_blank" :href="`/publisher/products/${cc.id}`" v-for="cc in otherCountryCodes">
                <svg class="icon" aria-hidden="true">
                  <use :xlink:href="MARKET_PLACE_MAP[cc.countryCode]?.icon"></use>
                </svg>
              </a>
            </span>
          </p>
          <p>
            <span># of Ratings:</span>
            <span>{{ productNumRatings }}</span>
          </p>
        </div>
        <div class="bottomBox">
          <div class="bottom-body">
            <div class="bottom-body-item">
              <div class="item">
                <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                <span class="item-text">Attribution</span>
              </div>
              <div class="status-box">
                <!-- <div class="status-box-title">Status</div> -->
                <showStatus type="Attribution" @editClick="editClick" :isActive="status == 'active'" />
                <div class="right-box" v-if="statusChangeOperations && statusChangeOperations?.length > 0">
                  <SvgIcon name="Frame" class="icon-info-frame" />
                  Until EOD {{ returnTime() }}
                </div>
              </div>
            </div>
            <div class="commission-box">
              <div class="status-box-title">Commission</div>
              <div class="commission-box-right">
                <div class="commission-box-content">
                  <div class="commission-box-content-text" v-if="commission">
                    {{ commission }}%
                  </div>
                  <div v-else class="commission-box-no-text">
                    -
                  </div>
                </div>
                <div class="commission-box-content-right">
                  {{ currencySymbol }} {{ estPayout }}
                </div>
              </div>

              <!-- <div>
                <SvgIcon name="lishijilu" class="icon-info-lishijilu" style="cursor: pointer" @click="
                  () => {
                    open = true
                    type = 'attribution'
                  }
                " />
              </div> -->
            </div>
          </div>
          <!-- <div class="bottom-body">
            <div class="bottom-body-item">
              <div class="item">
                <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                <span class="item-text">Associate</span>
              </div>
              <div class="status-box">
               
                <showStatus type="Associate" @editClick="editClick" :isActive="associateStatus == 'active'" />
                <div class="right-box red" v-if="associateCommissionChangeOperations">
                  <SvgIcon name="Frame" class="icon-info-frame" v-if="returnAssociateTime() > 0" />
                  {{ returnAssociateTime() }} days left
                </div>
              </div>
            </div>
            <div class="commission-box">
              <div class="status-box-title">Commission</div>
              <div class="commission-box-right">
                <div class="commission-box-content">
                  <div class="commission-box-content-text" v-if="associateCommission">
                    {{ associateCommission }}%
                  </div>
                  <div v-else class="commission-box-no-text">
                    -
                  </div>
                </div>
                <div class="commission-box-content-right">
                  {{ currencySymbol
                  }}{{
                    Number(associateEstPayout)?.toFixed(2)
                  }}
                </div>
              </div>
           
              <div>
                <a-popover overlayClassName="test" :overlayInnerStyle="{ padding: '8px' }" placement="left"
                  :mouseEnterDelay="0.5">
                  <template #content>
                    <div class="popover-content">
                      <div class="popover-content-item">
                        <div class="popover-item-top">
                          <img src="../../../../assets/images/img/attr.png" alt="" class="popover-img">
                          <div class="popover-item-top-right">
                            <Icon name="Frame" />
                            <template v-if="associateCommissionChangeOperations">
                              <span class="popover-title">Until {{
                                moment(associateCommissionChangeOperations[0]?.displayTime)
                                  .tz(COUNTRY_TIME_TZ[countryCode])
                                  .format('MM/DD') }}</span>
                            </template>
                            <template v-else>
                              <span class="popover-title popover-title-no">-</span>
                            </template>
                          </div>
                        </div>
                        <div class="popover-item-content">
                          <div class="popover-item-content-item" style="padding-top: 5px;">
                            <span class="popover-item-content-item-title">
                              Commission:
                            </span>
                            <span class="popover-item-content-item-text color">
                              {{ commission && status == 'active' ? commission : '--' }}%
                            </span>
                          </div>
                          <div class="popover-item-content-item" style="padding-bottom: 8px;">
                            <span class="popover-item-content-item-title">
                              Est. Payout:
                            </span>
                            <span class="popover-item-content-item-text" style="color: rgba(230, 130, 0, 1);">
                              {{ commission && status == 'active' ? currencySymbol +
                                Number(estPayout)?.toFixed(2)
                                : '-' }}
                             
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="popover-content-item">
                        <div class="popover-item-top">
                          <img src="../../../../assets/images/img/ass.png" alt="" class="popover-img">
                          <div class="popover-item-top-right">
                            <Icon name="Frame" />
                            <span class="popover-title">
                              <template v-if="commissionChangeOperations">
                                <span class="popover-title">Until {{
                                  moment(commissionChangeOperations[0]?.displayTime)
                                    .tz(COUNTRY_TIME_TZ[countryCode])
                                    .format('MM/DD') }}</span>
                              </template>
                              <template v-else>
                                <span class="popover-title popover-title-no">-</span>
                              </template>
                            </span>
                          </div>
                        </div>
                        <div class="popover-item-content">
                          <div class='popover-item-content-top-two' v-if="accCommission">
                            <div class='popover-item-content-top-two-title'>
                              Associate({{ originalAssociateCommission }}%)
                              <img class="equal" :src="require('@/assets/images/img/equal.png')"
                                alt="Commission rate adjustment policy"
                                v-if="originalAssociateCommission <= accCommission" />
                              <img class="equal" :src="require('@/assets/images/img/greater.png')" v-else
                                alt="Commission rate adjustment policy" />
                              Creator Connections ({{ accCommission }}%)
                            </div>
                            <div class="popover-item-content-top-two-content"
                              v-if="originalAssociateCommission <= accCommission">
                              all payments are settled directly by Amazon
                            </div>
                            <div class="popover-item-content-top-two-content" v-else>
                              Commission difference will be paid via ArtemisAds
                            </div>
                          </div>
                          <div class="popover-item-content">
                            <div class="popover-item-content-item" style="padding-top: 5px;">
                              <span class="popover-item-content-item-title">
                                Commission:
                              </span>
                             
                              <span class="popover-item-content-item-text" v-if="accCommission">
                                {{ originalAssociateCommission }}%-{{ accCommission }}% = <span class="commission-rate">
                                  {{ Math.max(0, originalAssociateCommission - accCommission) }}%
                                </span>
                              </span>
                              <span v-else class="popover-item-content-item-text color">
                                {{ associateCommission ? associateCommission : '--' }}%
                              </span>
                            </div>
                            <div class="popover-item-content-item" style="padding-bottom: 8px;">
                              <span class="popover-item-content-item-title">
                                Est. Payout:
                              </span>
                              <span class="popover-item-content-item-text" style="color: rgba(230, 130, 0, 1);">
                                {{ currencySymbol
                                }}{{
                                  Number(associateEstPayout)?.toFixed(2)
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="popover-content-item">
                        <div class="popover-item-top">
                          <img src="../../../../assets/images/img/cc.png" alt="" class="popover-img">
                        </div>
                        <div class="popover-item-content" v-if="accCommission">
                          <div class="popover-item-content-item" style="padding-top: 5px;">
                            <span class="popover-item-content-item-title">
                              Amazon Commission:
                            </span>
                            <span class="popover-item-content-item-text color">
                              {{ accCommission ? accCommission : '-' }}%
                            </span>
                          </div>
                          <div class="popover-item-content-item" style="padding-bottom: 8px;">
                            <span class="popover-item-content-item-title">
                              all payments are settled directly by <span class="amazon">Amazon</span>
                            </span>

                          </div>
                        </div>
                        <div v-else class="popover-item-content-item-title-not">
                          The brand has not authorized ACC, or you have not accept the ACC Campaign for this product.
                        </div>
                      </div>
                    </div>
                  </template>
                  <SvgIcon name="wenhao-tianchong" class="icon-info-tianchong-mid" />
                </a-popover>

              </div>
            </div>
          </div> -->
          <div class="bottom-body">
            <div class="bottom-body-item">
              <div class="item">
                <img src="../../../../assets/images/img/atac.png" alt="" class="icon" />
                <span class="item-text">Creator Connections</span>
              </div>
              <div class="status-box">
                <!-- <div class="status-box-title">Status</div> -->
                <div v-if="accCommission">
                  <showStatus type="creatorConnections" :isActive="accCommission" />

                </div>
                <div v-else class="commission-box-no-status popover-title-no">
                  -
                  <div>
                    <a-popover overlayClassName="test" :overlayInnerStyle="{ padding: '8px' }" placement="left"
                      :mouseEnterDelay="0.5">
                      <template #content>
                        <div class="popover-content">

                          <div class="popover-content-item">
                            <div class="popover-item-top">
                              <img src="../../../../assets/images/img/cc.png" alt="" class="popover-img">
                            </div>
                            <div class="popover-item-content" v-if="accCommission">
                              <div class="popover-item-content-item" style="padding-top: 5px;">
                                <span class="popover-item-content-item-title">
                                  Amazon Commission:
                                </span>
                                <span class="popover-item-content-item-text color">
                                  {{ accCommission ? accCommission : '-' }}%
                                </span>
                              </div>
                              <div class="popover-item-content-item" style="padding-bottom: 8px;">
                                <span class="popover-item-content-item-title">
                                  all payments are settled directly by <span class="amazon">Amazon</span>
                                </span>

                              </div>
                            </div>
                            <div v-else class="popover-item-content-item-title-not">
                              The brand has not authorized ACC, or you have not accept the ACC Campaign for this
                              product.
                            </div>
                          </div>
                        </div>
                      </template>
                      <SvgIcon name="wenhao-tianchong" class="icon-info-tianchong-bottom" />
                    </a-popover>

                  </div>
                </div>

              </div>
            </div>
            <div class="commission-box">
              <div class="status-box-title">Commission</div>

              <div class="commission-box-content gray" v-if="accCommission">
                <div class="commission-box-content-text" >
                  {{ accCommission }}%
                </div>
               
              </div>
               <div v-else class="popover-title-no">
                  -
                </div>


              <div v-if="accCommission">
                <a-popover overlayClassName="test" :overlayInnerStyle="{ padding: '8px' }" placement="left"
                  :mouseEnterDelay="0.5">
                  <template #content>
                    <div class="popover-content">
                      <div class="popover-content-item">
                        <div class="popover-item-top">
                          <img src="../../../../assets/images/img/attr.png" alt="" class="popover-img">
                          <div class="popover-item-top-right">
                            <Icon name="Frame" />
                            <template v-if="associateCommissionChangeOperations">
                              <span class="popover-title">Until {{
                                moment(associateCommissionChangeOperations[0]?.displayTime)
                                  .tz(COUNTRY_TIME_TZ[countryCode])
                                  .format('MM/DD') }}</span>
                            </template>
                            <template v-else>
                              <span class="popover-title">-</span>
                            </template>
                          </div>
                        </div>
                        <div class="popover-item-content">
                          <div class="popover-item-content-item" style="padding-top: 5px;">
                            <span class="popover-item-content-item-title">
                              Commission:
                            </span>
                            <span class="popover-item-content-item-text color">
                              {{ commission && status == 'active' ? commission : '-' }}%
                            </span>
                          </div>
                          <div class="popover-item-content-item" style="padding-bottom: 8px;">
                            <span class="popover-item-content-item-title">
                              Est. Payout:
                            </span>
                            <span class="popover-item-content-item-text" style="color: rgba(230, 130, 0, 1);">
                              {{ commission && status == 'active' ? currencySymbol +
                                Number(estPayout)?.toFixed(2)
                                : '-' }}
                              <!-- {{ product.currencySymbol
                            }}{{ Number(product.estPayout)?.toFixed(2) }} -->
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="popover-content-item">
                        <div class="popover-item-top">
                          <img src="../../../../assets/images/img/ass.png" alt="" class="popover-img">
                          <div class="popover-item-top-right">
                            <Icon name="Frame" />
                            <span class="popover-title">
                              <template v-if="commissionChangeOperations">
                                <span class="popover-title">Until {{
                                  moment(commissionChangeOperations[0]?.displayTime)
                                    .tz(COUNTRY_TIME_TZ[countryCode])
                                    .format('MM/DD') }}</span>
                              </template>
                              <template v-else>
                                <span class="popover-title">-</span>
                              </template>
                            </span>
                          </div>
                        </div>
                        <div class="popover-item-content">
                          <div class='popover-item-content-top-two' v-if="accCommission">
                            <div class='popover-item-content-top-two-title'>
                              Associate({{ originalAssociateCommission }}%)
                              <img class="equal" :src="require('@/assets/images/img/equal.png')"
                                alt="Commission rate adjustment policy"
                                v-if="originalAssociateCommission <= accCommission" />
                              <img class="equal" :src="require('@/assets/images/img/greater.png')" v-else
                                alt="Commission rate adjustment policy" />
                              Creator Connections ({{ accCommission }}%)
                            </div>
                            <div class="popover-item-content-top-two-content"
                              v-if="originalAssociateCommission <= accCommission">
                              all payments are settled directly by Amazon
                            </div>
                            <div class="popover-item-content-top-two-content" v-else>
                              Commission difference will be paid via ArtemisAds
                            </div>
                          </div>
                          <div class="popover-item-content">
                            <div class="popover-item-content-item" style="padding-top: 5px;">
                              <span class="popover-item-content-item-title">
                                Commission:
                              </span>
                              <!-- product.originalAssociateCommission -->
                              <span class="popover-item-content-item-text" v-if="accCommission">
                                {{ originalAssociateCommission }}%-{{ accCommission }}% = <span class="commission-rate">
                                  {{ Math.max(0, originalAssociateCommission - accCommission) }}%
                                </span>
                              </span>
                              <span v-else class="popover-item-content-item-text color">
                                {{ associateCommission ? associateCommission : '-' }}%
                              </span>
                            </div>
                            <div class="popover-item-content-item" style="padding-bottom: 8px;">
                              <span class="popover-item-content-item-title">
                                Est. Payout:
                              </span>
                              <span class="popover-item-content-item-text" style="color: rgba(230, 130, 0, 1);">
                                {{ currencySymbol
                                }}{{
                                  Number(associateEstPayout)?.toFixed(2)
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="popover-content-item">
                        <div class="popover-item-top">
                          <img src="../../../../assets/images/img/cc.png" alt="" class="popover-img">
                        </div>
                        <div class="popover-item-content" v-if="accCommission">
                          <div class="popover-item-content-item" style="padding-top: 5px;">
                            <span class="popover-item-content-item-title">
                              Amazon Commission:
                            </span>
                            <span class="popover-item-content-item-text color">
                              {{ accCommission ? accCommission : '-' }}%
                            </span>
                          </div>
                          <div class="popover-item-content-item" style="padding-bottom: 8px;">
                            <span class="popover-item-content-item-title">
                              all payments are settled directly by <span class="amazon">Amazon</span>
                            </span>

                          </div>
                        </div>
                        <div v-else class="popover-item-content-item-title-not">
                          The brand has not authorized ACC, or you have not accept the ACC Campaign for this product.
                        </div>
                      </div>
                    </div>
                  </template>
                  <SvgIcon name="wenhao-tianchong" class="icon-info-tianchong-bottom" />
                </a-popover>

              </div>
            </div>
          </div>
        </div>
      </div>
      <slot name="deals"></slot>
      <slot name="link"></slot>
      <CommissionChartModal :type="type" v-model:open="open" :productId="productId" :brandId="brandId"
        :countryCode="countryCode" />
    </div>
  </div>
</template>

<script setup>
import { ref, inject, computed, onMounted } from 'vue'
import { MARKET_PLACE_MAP } from '~/contants/publisher'
import { HistoryOutlined, PieChartOutlined } from '@ant-design/icons-vue'
import CommissionChartModal from './commissionHistoryChartModal.vue'
import PriceDealLayout from '~/components/PriceDealLayout'
import showStatus from '../../../seller/Brands/components/showStatus.vue'
import SvgIcon from '~/components/SvgIcon.vue'
import { COUNTRY_TIME_TZ } from '~/contants/common'
import moment from 'moment'
const productId = inject('productId')
const type = ref('attribution')
const {
  status,
  associateStatus,
  imageUrl,
  title,
  productUrl,
  asin,
  brandName,
  brandId,
  category,
  categoryId,
  categoryLevel,
  currencySymbol,
  price,
  availiability,
  commission,
  associateCommission,
  originalAssociateCommission,
  productStarRating,
  estPayout,
  productNumRatings,
  countryCode,
  otherCountryCodes,
  bestSellerRank,
  combineDeal,
  imageUrls,
  statusChangeOperations,
  associateCommissionChangeOperations,
  associateStatusChangeOperations,
  associateEstPayout,
  accCommission
} = defineProps([
  'status',
  'associateStatus',
  'imageUrl',
  'title',
  'productUrl',
  'asin',
  'brandName',
  'brandId',
  'category',
  'categoryId',
  'categoryLevel',
  'currencySymbol',
  'price',
  'availiability',
  'commission',
  'productStarRating',
  'estPayout',
  'productNumRatings',
  'countryCode',
  'otherCountryCodes',
  'bestSellerRank',
  'combineDeal',
  'imageUrls',
  'associateCommission',
  'originalAssociateCommission',
  'statusChangeOperations',
  'associateCommissionChangeOperations',
  'associateStatusChangeOperations',
  'associateEstPayout',
  'accCommission'
])
// const timezone = COUNTRY_TIME_TZ[countryCode]

const selectImageUrl = ref('')
const selectImageIndex = ref(0)
const availiabilityText = computed(() => {
  if (availiability) {
    return availiability
      .toLowerCase()
      .split('_')
      .map((value) => value.charAt(0).toUpperCase() + value.slice(1))
      .join(' ')
  } else {
    return ''
  }
})
const returnTime = () => {
  if (statusChangeOperations && statusChangeOperations?.length > 0) {
    let timezone = COUNTRY_TIME_TZ[countryCode]
    return moment(statusChangeOperations[0].displayTime).tz(timezone).format('MM/DD')
  }
  // associateCommissionChangeOperations
}
const returnAssociateTime = () => {
  let diffDays = 0
  if (associateStatusChangeOperations && associateStatusChangeOperations?.length > 0) {
    let timezone = COUNTRY_TIME_TZ[countryCode]
    const time = associateStatusChangeOperations[0].displayTime
    diffDays = Math.abs(moment().tz(timezone).diff(moment(time).tz(timezone), 'days'))
  }
  return diffDays
}
const onGoToProductList = () => {
  localStorage.setItem(
    'previewCategory',
    `${countryCode}_${categoryId}_${categoryLevel}`
  )
}
const changeImageUrl = (item, index) => {
  selectImageUrl.value = item
  selectImageIndex.value = index
}
const open = ref(false)
</script>

<style scoped lang="less">
.popover-title-no{
  // opacity: 0.3 !important;
  color:rgba(15, 6, 41, 0.3) !important;
}
.popover-item-content-item-title-not {
  // padding-left: 16px;
  padding: 8px 16px;
  font-family: Sora;
  font-weight: 400;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0.3px;
  color: rgba(15, 6, 41, 0.5);
}

.popover-content {
  border-radius: var(--Radius-Radius-6, 6px);
  background: #fff;
  padding: 8px;
  width: 357px;

  .popover-content-item:not(:first-child) {
    margin-top: 16px;
  }

  .popover-content-item {

    background-color: rgba(249, 249, 251, 1);
    border-radius: var(--Radius-Radius-6, 6px);

    .popover-img {
      // width: 64px;
      height: 16px;
    }

    .popover-item-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid rgba(232, 229, 237, 1);
      padding: 8px 16px;

      .popover-item-top-right {
        display: flex;
        align-items: center;
        gap: 7px;

        .popover-title {
          font-family: Sora;
          font-weight: 400;
          font-style: Regular;
          font-size: 11px;
          leading-trim: NONE;
          line-height: 20px;
          letter-spacing: 0.4px;
          color: rgba(15, 6, 41, 0.7);
        }
      }
    }

    .popover-item-content {
      .equal {
        width: 7px;
      }

      // margin-top: 5px;
      // margin: 5px 16px 0;

      .popover-item-content-item {
        padding-left: 20px;

        .popover-item-content-item-title {
          font-family: Sora;
          font-weight: 400;
          font-size: 12px;
          leading-trim: NONE;
          line-height: 18px;
          letter-spacing: 0.3px;
          color: rgba(15, 6, 41, 0.5);

          .amazon {
            color: rgba(15, 6, 41, 0.7);
            font-family: Sora;
            font-weight: 700;
            font-size: 11px;
            leading-trim: NONE;
            line-height: 18px;
            letter-spacing: 0.3px;

          }
        }

        .popover-item-content-item-text {
          font-family: Sora;
          font-weight: 500;
          font-size: 12px;
          leading-trim: NONE;
          line-height: 18px;
          letter-spacing: 0.3px;
          color: rgba(15, 6, 41, 0.9);

          .commission-rate {
            color: rgba(121, 79, 242, 1);
          }
        }
      }

      .popover-item-content-top-two {
        padding: 8px 10px;
        background-color: rgba(255, 255, 255, 1);
        border-radius: 4px;
        margin: 5px 16px;

        .popover-item-content-top-two-title {
          font-family: Sora;
          font-weight: 500;
          font-style: Medium;
          font-size: 11px;
          leading-trim: NONE;
          line-height: 18px;
          letter-spacing: 0.3px;
          color: rgba(15, 6, 41, 1);
        }

        .popover-item-content-top-two-content {
          font-family: Sora;
          font-weight: 400;
          font-size: 11px;
          leading-trim: NONE;
          line-height: 18px;
          letter-spacing: 0.3px;
          color: rgba(15, 6, 41, 0.5);
          padding-top: 6px;
        }

      }
    }
  }

}

.information {
  display: flex;
  gap: 24px;

  .icon-info-tianchong-bottom {
    color: rgba(15, 6, 41, 0.3);
    margin-left: 8px;
    font-size: 14px;
  }

  .icon-info-tianchong-mid {
    color: rgba(15, 6, 41, 0.3);
    margin-left: 8px;
    font-size: 14px;
  }

  .left {
    width: 256px;

    .top-img {
      width: 256px;
      height: 256px;
      border-radius: 8px;
      background: #eeedf2;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      :deep(img) {
        max-width: 256px !important;
        max-height: 256px !important;
        object-fit: contain;
      }

      &.show-bg {
        background-color: var(--bg-gray-2);
      }
    }

    .bottomUrlContainer {
      width: 256px;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      padding-bottom: 5px;

      /* 添加底部内边距，避免滚动条遮挡内容 */
      /* 滚动条样式美化 */
      &::-webkit-scrollbar {
        height: 6px;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
      }
    }

    .bottomUrl {
      display: inline-flex;
      /* 改为inline-flex，配合父容器的white-space: nowrap */
      margin-top: 9px;
      gap: 8px;

      /* 添加间距，让图片项之间有间隔 */
      .bottomUrlItem {
        width: 45.6px;
        height: 45.6px;
        flex-shrink: 0;
        /* 防止图片项被压缩 */
        border-radius: var(--Radius-Radius-6, 6px);
        background: #eeedf2;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        cursor: pointer;
        transition: border-color 0.2s ease;

        :deep(img) {
          max-width: 44.6px !important;
          max-height: 43.6px !important;
          object-fit: contain;
        }
      }
    }

    img {
      width: 256px;
      height: 256px;
      border-radius: 8px;
      object-fit: contain;
    }
  }

  .right {
    flex: 1;
    width: 0;

    .icon-info-lishijilu {
      font-size: 18px;
      color: #0f0629;
      margin-left: 6px;
      margin-top: 4px;

    }

    .commission-box-right {
      display: flex;
      border: 1px solid rgba(131, 92, 242, 0.4);
      border-radius: 6px;
      overflow: hidden;
    }

    .commission-box-content-right {
      background-color: rgba(131, 92, 242, 0.1);
      padding: 3px 6px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      font-family: Sora;
      font-weight: 500;
      font-style: Medium;
      font-size: 13px;
      leading-trim: NONE;
      line-height: 15.4px;
      letter-spacing: 0px;
      color: rgba(105, 74, 194, 1);
    }

    .gray {
      border-radius: 6px !important;

      background-color: rgba(232, 229, 237, 1) !important;
      border: 1px solid rgba(204, 200, 220, 1) !important;

      .commission-box-content-text {
        color: rgba(15, 6, 41, 1) !important;
      }
    }

    .commission-box-content {
      display: flex;
      padding: 3px 6px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      color: #fff;
      // border-radius: var(--Radius-Radius-4, 4px);
      background: var(--Brand-Primary_Loading, #8A64F4);

      .commission-box-content-text {

        color: #ffffff;

        font-family: "Sora";
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 14px;
        letter-spacing: 0.4px;
      }

      .commission-box-no-text {
        color:rgba(15, 6, 41, 0.3) !important;
        font-family: "Sora";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        letter-spacing: 0.3px;
      }
    }

    .bottomBox {
      border-radius: var(--Radius-Radius-8, 8px);
      background: #f8f7fc;
    }

    .bottom-body {
      display: flex;
      gap: 12px;

      .commission-box {
        display: flex;
        flex: 1;
        align-items: center;
      }

      .status-box-title {
        color: #0f0629;
        font-family: 'Sora';
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0.3px;
        opacity: 0.5;
        margin-right: 10px;
      }

      .bottom-body-item {
        padding: 16px;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .item {
          display: flex;
          align-items: center;
          gap: 8px;

          .icon {
            width: 20px;
            height: 20px;
          }

          .item-text {
            color: #0f0629;

            font-family: 'Sora';
            font-size: 14px;
            font-style: normal;
            font-weight: 500;

            letter-spacing: 0.4px;
            opacity: 0.9;
          }
        }

        .commission-box-no-status {
          display: flex;
          align-items: center;
        }

        .status-box {
          display: flex;
          width: 210px;
          align-items: center;
          .red {
            border: 1px solid rgba(242, 85, 68, 0.4);
            background-color: rgba(242, 85, 68, 0.1) !important;
            color: rgba(235, 78, 61, 1) !important;
            font-family: Sora;
            font-weight: 500;
            font-style: Medium;
            font-size: 11px;
            leading-trim: NONE;
            line-height: 20px;
            letter-spacing: 0.4px;

          }

          .right-box {
            display: flex;
            align-items: center;
            gap: 4px;
            padding: 3px 4px;
            font-family: Sora;
            font-weight: 400;
            font-style: Regular;
            font-size: 11px;
            leading-trim: NONE;
            line-height: 20px;
            letter-spacing: 0.4px;
            background-color: #fff;
            border-radius: 6px;
            margin-left: 10px;
            color: rgba(15, 6, 41, 0.7);

            .icon-info-frame {
              font-size: 14px;
            }
          }

        }
      }
    }

    .info {
      gap: 24px;
      display: flex;
      position: relative;
      padding-bottom: 24px;
      flex-direction: column;

      .info-head {
        >p {
          font-weight: 500;
          font-size: 20px;
          color: var(--dark-1);
          letter-spacing: 0.5px;
          line-height: 28px;
        }

        >h1 {
          font-weight: 600;
          font-size: 16px;
          color: var(--dark-1);
          letter-spacing: 0.3px;
          line-height: 22px;
          margin-top: 6px;
          width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;

          display: -webkit-box;
          -webkit-line-clamp: 2;
          /* autoprefixer: ignore next */
          -webkit-box-orient: vertical;
          max-height: 44px;
          margin-bottom: 16px;
        }

        >a {
          color: var(--dark-1);
          background: var(--bg-gray-8);
          border-radius: 8px;
          padding: 0 8px;
          height: 28px;
          display: inline-flex;
          line-height: 28px;
          font-size: 16px;
          font-weight: 500;
          align-items: center;

          &:hover {
            background: var(--bg-gray-5);
          }

          >.icon {
            margin-left: 8px;
            font-size: 20px;
          }
        }
      }

      .info-body {
        position: relative;
        display: grid;
        gap: 16px;
        grid-template-columns: 1fr 1fr;
        gap: 0 100px;

        &::after {
          content: '';
          display: block;
          width: 1px;
          background: var(--border-4);
          position: absolute;
          left: 50%;
          top: 10px;
          height: calc(100% - 20px);
        }

        >p {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          height: 44px;

          >span {
            font-size: 14px;
            color: var(--dark-3);
            letter-spacing: 0.4px;
            align-self: center;
            font-weight: 500;

            &:last-child {
              font-weight: 600;
              text-align: right;
              line-height: 20px;
              color: var(--dark-1);
            }

            >a {
              color: var(--dark-1);
              text-decoration: underline;
            }
          }

          .marketplace {
            display: flex;
            height: 20px;
            align-items: center;
            gap: 4px;
            padding: 0 6px;
            background-color: var(--bg-gray-8);
            border-radius: 4px;

            span {
              margin-top: -2px;
              line-height: 20px;
              position: relative;
              color: var(--dark-2);
            }
          }

          .commission {
            display: flex;
            align-items: center;
            gap: 10px;

            >span {
              border-radius: 4px;
              background-color: var(--primary);
              line-height: 20px;
              font-size: 14px;
              color: var(--color-white);
              font-weight: 700;
              letter-spacing: 0.4px;
              padding: 0 6px;
            }

            .history {
              border: none;
              padding: 0;
              line-height: 32px;
              display: flex;
              box-shadow: none;
              color: var(--dark-3);

              .iconfont {
                height: 26px;
                font-size: 20px;
                vertical-align: middle;
              }

              :deep(svg) {
                width: 20px;
                height: 20px;
                fill: var(--dark-3);
              }
            }
          }
        }

        .other-countries {
          border-radius: 4px;
          background-color: var(--bg-gray-8);

          >a {
            height: 24px;
            padding: 0 8px;
            margin-right: -4px;
            display: inline-block;

            &:last-of-type {
              margin-right: 0;
            }

            &:hover {
              border-radius: 4px;
              background-color: var(--bg-gray-4);
            }

            &:active {
              background-color: var(--bg-gray-5);
            }

            >.icon {
              font-size: 20px;
              margin-top: 2px;
            }
          }
        }
      }
    }
  }
}
</style>
